import { createTheme, Pagination, Table } from "@mantine/core";
import { INK_SHADES } from "./colors";

export const TableTheme = createTheme({
  components: {
    Table: Table.extend({
      defaultProps: {
        horizontalSpacing: "s4",
        verticalSpacing: "s3",
        borderColor: "ink.0",
        highlightOnHover: true,
        highlightOnHoverColor: "brand.0",
        stickyHeader: true,
      },
      styles: theme => ({
        thead: {
          "& tr": {
            borderBottom: "none",
          },
        },
        th: {
          backgroundColor: INK_SHADES[25],
          boxShadow: `inset 0 -1px 0 var(--mantine-color-ink-1)`,
          fontSize: theme.fontSizes.xs,
          fontWeight: theme.fontWeights.bold,
          letterSpacing: "0.04em",
          textTransform: "uppercase",
          color: "var(--mantine-color-ink-4)",
          whiteSpace: "nowrap",
        },
        td: {
          color: "var(--mantine-color-ink-7)",
          verticalAlign: "middle",
        },
        tr: {
          transition: "background 0.12s cubic-bezier(0.22, 1, 0.36, 1)",
          "&[data-selected]": {
            backgroundColor: "var(--mantine-color-brand-0)",
          },
          "&:has([data-action-pill])": {
            boxShadow: `inset 3px 0 0 var(--mantine-color-amber-5)`,
          },
          "&[data-clickable]": {
            cursor: "pointer",
          },
        },
      }),
    }),
    Pagination: Pagination.extend({
      defaultProps: {
        size: "md",
        radius: "sm",
        gap: "s2",
        color: "brand.6",
      },
      styles: theme => ({
        control: {
          fontSize: theme.fontSizes.sm,
          fontWeight: theme.fontWeights.medium,
          fontVariantNumeric: "tabular-nums",
          color: "var(--mantine-color-ink-7)",
          backgroundColor: INK_SHADES[0],
          borderColor: "var(--mantine-color-ink-2)",
          "&:hover:not(:disabled):not([data-disabled]):not([data-active])": {
            backgroundColor: INK_SHADES[25],
            borderColor: "var(--mantine-color-ink-3)",
          },
          "&[data-active]": {
            backgroundColor: "var(--pagination-active-bg)",
            borderColor: "var(--pagination-active-bg)",
            color: "var(--pagination-active-color, var(--mantine-color-white))",
            fontWeight: theme.fontWeights.bold,
          },
          "&:disabled, &[data-disabled]": {
            color: "var(--mantine-color-ink-3)",
            borderColor: "var(--mantine-color-ink-1)",
            backgroundColor: INK_SHADES[0],
            opacity: 1,
            cursor: "not-allowed",
          },
        },
      }),
    }),
  },
});
